import { TRANSFER_FILTERABLE_STATUSES, TRANSFER_STATUS_TO_LABEL, TRANSFER_TYPE_TO_SHORT_LABEL } from "../constants"

import type { TransferStatus, TransferType } from "@/graphql/codegen/graphql"
import { UserCreatedRecordType } from "@/graphql/codegen/graphql"
import { useGetUserOptions } from "@/hooks/useGetUserOptions"
import { useGetWarehouseOptions } from "@/hooks/useGetWarehouseOptions"
import type { Option } from "@/types/form-fields"

const TYPE_OPTIONS: Option<TransferType>[] = Object.entries(TRANSFER_TYPE_TO_SHORT_LABEL).map(([value, label]) => ({
  value: value as TransferType,
  label,
}))

const STATUS_OPTIONS: Option<TransferStatus>[] = TRANSFER_FILTERABLE_STATUSES.map((status) => ({
  value: status,
  label: TRANSFER_STATUS_TO_LABEL[status],
}))

interface UseTransferFilterOptionsReturn {
  typeOptions: Option<TransferType>[]
  statusOptions: Option<TransferStatus>[]
  warehouseOptions: Option<string>[]
  isWarehouseOptionsFetching: boolean
  createdByOptions: Option<string>[]
  isCreatedByOptionsFetching: boolean
}

export const useTransferFilterOptions = (): UseTransferFilterOptionsReturn => {
  const { warehouseOptions, isFetching: isWarehouseOptionsFetching } = useGetWarehouseOptions({
    isInventoryRelated: true,
  })
  const { userOptions: createdByOptions, isFetching: isCreatedByOptionsFetching } = useGetUserOptions({
    createdRecordTypes: [UserCreatedRecordType.Transfer],
  })

  return {
    typeOptions: TYPE_OPTIONS,
    statusOptions: STATUS_OPTIONS,
    warehouseOptions,
    isWarehouseOptionsFetching,
    createdByOptions,
    isCreatedByOptionsFetching,
  }
}
